import { Component, EventEmitter, OnInit } from "@angular/core";
import { CatConceptoCostosService } from "../../servicios/cat-concepto-costos.service";
import { CatConceptosService } from "../../servicios/cat-conceptos.service";
import { CatUnidadMedidasService } from "../../servicios/cat-unidad-medidas.service";
import { CatUnidadCobrosService } from "../../servicios/cat-unidad-cobros.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { MenuItem, SelectItem } from "primeng/api";
import { CatConceptoCostos, AuxJasper, ParametroJasper, Privilegios } from "../../entidades/entidades";
import * as FileSaver from 'file-saver';
import { CatConceptos } from "../../entidades/entidades";
import { CatUnidadMedidas } from "../../entidades/entidades";
import { CatUnidadCobros } from "../../entidades/entidades";
import { Router } from "@angular/router";
import { PrivilegiosService } from 'app/servicios/privilegios.service';

@Component({
  selector: "app-cat-concepto-costos-grid",
  templateUrl: "./cat-concepto-costos-grid.component.html",
  styleUrls: ["./cat-concepto-costos-grid.component.css"],
})
export class CatConceptoCostosGridComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  catConceptos: SelectItem[];
  catUnidadMedidas: SelectItem[];
  catUnidadCobros: SelectItem[];
  catConceptoCostos: CatConceptoCostos[];
  itemsMenu: MenuItem[];
  public auxJasper: AuxJasper;
  columnasTabla: any[];
  privilegios: boolean = false;
  clonedCatConceptoCostos: { [s: string]: CatConceptoCostos } = {};
    public jasperInputExporta$ = new EventEmitter<AuxJasper>();
    public jasperInput$ = new EventEmitter<AuxJasper>();
    public display: boolean = false; 
    
  constructor(
   private catConceptoCostosService: CatConceptoCostosService,
    private catConceptosService: CatConceptosService,
    private catUnidadMedidasService: CatUnidadMedidasService,
    private router: Router,
    private privilegiosService: PrivilegiosService,
    private catUnidadCobrosService: CatUnidadCobrosService,
  ) {}

  async ngOnInit() {
    const tienePermiso = await this.getPrivilegios();
    debugger;
    if (!tienePermiso) {
     // this.progressBar = false;
      this.muestraMensaje.warning("No tiene permiso para acceder a este módulo.", "top", "center");
      return; // Detener ejecución
    }

   // await this.getPrivilegios();
    await this.getAllCatConceptos();
    await this.getAllCatUnidadMedidas();
    await this.getAllCatUnidadCobros();
    await this.getAllCatConceptoCostos();
    

    // ===============================================================
    //Opciones del menu
    // ===============================================================
    // prettier-ignore
    this.itemsMenu = [
      {label: "Guardar",   icon: "pi pi-save",    command: (event) => {this.guardarGridCatConceptoCostos();} },
      {label: "Refrescar", icon: "pi pi-refresh", command: (event) => {this.getAllCatConceptoCostos();} },
    ];

    if(this.privilegios)
      this.itemsMenu.unshift({label: "Agregar",   icon: "pi pi-file-o",  command: () => this.add(), });

    // ===============================================================
    //Opciones de la tabla
    // ===============================================================
    // prettier-ignore
    this.columnasTabla = [
      {field: "operacion",header: "Editar", ordenar: false, styleHeader: "width: 80px;"},
     /*  {field: "id", header: "Id",ordenar: false, styleHeader: "width: 30px;",}, */
      {field: "idConcepto", header: "Concepto",ordenar: true, styleHeader: "width: 700px;",},
      {field: "idUnidadMedida", header: "Unidad Medida",ordenar: true, styleHeader: "width: 200px;",},
      {field: "idUnidadCobro", header: "Unidad Cobro",ordenar: true, styleHeader: "width: 200px;",},
      {field: "fechaIni", header: "Fecha Ini",ordenar: true, styleHeader: "width: 150px;",},
      {field: "fechaFin", header: "Fecha Fin",ordenar: true, styleHeader: "width: 150px;",},
      {field: "costoUmas", header: "Costo Umas",ordenar: true, styleHeader: "width: 150px;",},
      {field: "costoPesos", header: "Costo Pesos",ordenar: true, styleHeader: "width: 150px;",},
      {field: "costoMinimo", header: "Costo Minimo",ordenar: true, styleHeader: "width: 150px;",},
      {field: "costoMaximo", header: "Costo Maximo",ordenar: true, styleHeader: "width: 150px;",},
      //{field: "acciones", header: "Eliminar",ordenar: false, styleHeader: "width: 80px;",},
    ];
  }
  //===============================================================
  //Agrega renglon en el grid
  //===============================================================
  // prettier-ignore
  add() {
    let catConceptoCostosNew = new CatConceptoCostos();
    catConceptoCostosNew.cambio = true;
    catConceptoCostosNew.id = 0;
    catConceptoCostosNew.numRow = this.catConceptoCostos.length + 1;
    this.catConceptoCostos.unshift(catConceptoCostosNew);
  }

  //===============================================================
  //Funciones de la tabla
  //===============================================================
  // prettier-ignore
  onEditInit(event) {
    let catConceptoCostosEdit = event.data;
    this.clonedCatConceptoCostos[catConceptoCostosEdit.numRow] = { ...catConceptoCostosEdit };
    catConceptoCostosEdit.cambio = true;
    catConceptoCostosEdit.baja = false;
  }

  // prettier-ignore
  onEditCancel(event) {
    let catConceptoCostosEdit = event.data;
    let index = this.catConceptoCostos.findIndex(
      (obj) => obj.numRow === catConceptoCostosEdit.numRow
    );
    this.catConceptoCostos[index] = { ...this.clonedCatConceptoCostos[catConceptoCostosEdit.numRow]};
  }

  // prettier-ignore
  onDelete(event, index: number) {
    event.cambio = false;
    event.baja = true;
  }

  // prettier-ignore
  async onEditComplete(event) {
    try {
      let catConceptoCostosEdit = event.data;

      //Valida si hay cambios
      if (
        catConceptoCostosEdit.id === this.clonedCatConceptoCostos[catConceptoCostosEdit.numRow].id &&
        catConceptoCostosEdit.idConcepto === this.clonedCatConceptoCostos[catConceptoCostosEdit.numRow].idConcepto &&
        catConceptoCostosEdit.idUnidadMedida === this.clonedCatConceptoCostos[catConceptoCostosEdit.numRow].idUnidadMedida &&
        catConceptoCostosEdit.idUnidadCobro === this.clonedCatConceptoCostos[catConceptoCostosEdit.numRow].idUnidadCobro &&
        catConceptoCostosEdit.fechaIni === this.clonedCatConceptoCostos[catConceptoCostosEdit.numRow].fechaIni &&
        catConceptoCostosEdit.fechaFin === this.clonedCatConceptoCostos[catConceptoCostosEdit.numRow].fechaFin &&
        catConceptoCostosEdit.costoUmas === this.clonedCatConceptoCostos[catConceptoCostosEdit.numRow].costoUmas &&
        catConceptoCostosEdit.costoPesos === this.clonedCatConceptoCostos[catConceptoCostosEdit.numRow].costoPesos &&
        catConceptoCostosEdit.costoMinimo === this.clonedCatConceptoCostos[catConceptoCostosEdit.numRow].costoMinimo &&
        catConceptoCostosEdit.costoMaximo === this.clonedCatConceptoCostos[catConceptoCostosEdit.numRow].costoMaximo 
      ) {
        let index = this.catConceptoCostos.findIndex((obj) => obj.numRow === catConceptoCostosEdit.numRow);
        this.catConceptoCostos[index] = {...this.clonedCatConceptoCostos[catConceptoCostosEdit.numRow]};
        return;
      }

      //Validaciones
      //throw new Error("No paso las validaciones.");

      catConceptoCostosEdit.cambio = true;
      catConceptoCostosEdit.baja = false;
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por onEditComplete");
    }
  }
  //===============================================================
  //Interaccion con servicios
  //===============================================================
  // prettier-ignore
  async guardarGridCatConceptoCostos() {
    try {
      for (let catConceptoCostosFor of this.catConceptoCostos) {
        if (catConceptoCostosFor.baja) {
          await this.deleteCatConceptoCostos(catConceptoCostosFor);
        } else if (catConceptoCostosFor.cambio) {
          catConceptoCostosFor.cambio = false;
          this.clonedCatConceptoCostos[catConceptoCostosFor.id] = { ...catConceptoCostosFor, };
          if (catConceptoCostosFor.id === 0) {
            const datoRetorno = await this.addCatConceptoCostos(catConceptoCostosFor);
            catConceptoCostosFor.id = datoRetorno.id;
          } else {
            await this.updateCatConceptoCostos(catConceptoCostosFor);
          }
        }
      }

      this.muestraMensaje.notification("Proceso Concluido.", "top", "center");
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por guardarCatConceptoCostos");
    }
  }

  // prettier-ignore
  async addCatConceptoCostos(catConceptoCostos) {
    try {
      const datoretorno = await this.catConceptoCostosService
        .add(catConceptoCostos)
        .toPromise();
      return datoretorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por addCatConceptoCostos");
    }
  }

  // prettier-ignore
  async getAllCatConceptoCostos() {
    try {
      const datoRetorno = await this.catConceptoCostosService.getAll().toPromise();
      for (var i = 0, len = datoRetorno.length; i < len; ++i){
        datoRetorno[i].fechaIni = new Date(datoRetorno[i].fechaIni);
        datoRetorno[i].fechaFin = new Date(datoRetorno[i].fechaFin);
      }
      this.catConceptoCostos = datoRetorno;
      for (var i = 0, len = this.catConceptoCostos.length; i < len; ++i){
        this.catConceptoCostos[i].numRow = i;
        this.clonedCatConceptoCostos[this.catConceptoCostos[i].numRow] = {...this.catConceptoCostos[i],        };
      } 
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllCatConceptoCostos");
    }
  }

  // prettier-ignore
  async updateCatConceptoCostos(catConceptoCostos: CatConceptoCostos) {
    try {
      const datoRetorno = await this.catConceptoCostosService
        .update(catConceptoCostos)
        .toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por updateCatConceptoCostos");
    }
  }

  // prettier-ignore
  async deleteCatConceptoCostos(catConceptoCostos: CatConceptoCostos) {
    try {
      const datoRetorno = await this.catConceptoCostosService
        .delete(catConceptoCostos.id)
        .toPromise();
      this.getAllCatConceptoCostos();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por deleteCatConceptoCostos");
    }
  }

  // prettier-ignore
  async getAllCatConceptos() {
    try {
      const datoRetorno = await this.catConceptosService.getAll().toPromise();
      this.catConceptos = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      this.catConceptos.unshift({ label: "Todos", value: null });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatConceptos");
    }
  }

  // prettier-ignore
  async getAllCatUnidadMedidas() {
    try {
      const datoRetorno = await this.catUnidadMedidasService.getAll().toPromise();
      this.catUnidadMedidas = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      this.catUnidadMedidas.unshift({ label: "Todos", value: null });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatUnidadMedidas");
    }
  }

  // prettier-ignore
  async getAllCatUnidadCobros() {
    try {
      const datoRetorno = await this.catUnidadCobrosService.getAll().toPromise();
      this.catUnidadCobros = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      this.catUnidadCobros.unshift({ label: "Todos", value: null });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatUnidadCobros");
    }
  }

  async export() {
      try {
        this.auxJasper = new AuxJasper();
        this.auxJasper.JasperReport.nombreReporte = "029_Conceptos_catalogo";
        this.auxJasper.JasperReport.tipo = "xlsx";
 
        this.jasperInput$.emit(null);
      } catch (e) {
        if (e.response) throw { message: e.response.data };
        else throw e;
      } finally {
        console.log("Paso por export");
      }
  }

  showDialog() {
    this.display = true;
  }

  getDescription(idConcepto: number): string {
    const concepto = this.catConceptos.find(concepto => concepto.value === idConcepto);
    return concepto ? concepto.label : '';
}
async getPrivilegios() {
  try {
    let objUrl = new Privilegios();
    objUrl.uuid = 'f9c79bc1-0015-4b1a-bcea-585444f57552';
    let conPrivilegio = await this.privilegiosService.GetPrivilegioByUUID(objUrl).toPromise();
    return conPrivilegio;
    console.log('privilegios', conPrivilegio)
  } catch (e) {
    if (e.response) throw { message: e.response.data };
    else throw e;
  } finally {
    console.log("Paso por getPrivilegios");
  }
}

}